import { getJson } from "../../core/http";

export function fetchReadingHistory({ page = 1, perPage = 20, feature = null } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  if (feature) params.set("feature", feature);
  return getJson(`/api/v1/reading_history?${params.toString()}`);
}
